import { seasonPreviewMediaConfig } from './mediaConfig';
function trimTrailingSlash(value) {
    return value.replace(/\/+$/, '');
}
function trimLeadingSlash(value) {
    return value.replace(/^\/+/, '');
}
function profileQuery(profile) {
    var raw = seasonPreviewMediaConfig.imageQueryLargeRaw;
    if (profile === 'large' && raw && raw.trim()) {
        return raw.trim().replace(/^\?/, '');
    }
    var value = profile === 'thumb'
        ? seasonPreviewMediaConfig.imageProfileLarge
        : seasonPreviewMediaConfig.imageProfileLarge;
    return (encodeURIComponent(seasonPreviewMediaConfig.imageQueryParam) +
        '=' +
        encodeURIComponent(value));
}
function appendQuery(url, query) {
    if (!query) {
        return url;
    }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + query;
}
function absolutePackImageUrl(imagePath) {
    var path = String(imagePath || '').trim();
    if (!path) {
        return '';
    }
    if (/^https?:\/\//i.test(path)) {
        return path;
    }
    return (trimTrailingSlash(seasonPreviewMediaConfig.staticBaseUrl) +
        '/' +
        trimLeadingSlash(path));
}
export function packLargeImageUrl(imagePath) {
    var url = absolutePackImageUrl(imagePath);
    if (!url) {
        return '';
    }
    return appendQuery(url, profileQuery('large'));
}
//# sourceMappingURL=packGalleryImageUrl.js.map